import React from "react";
import {
  LocalizationProvider,
  PickersDay,
  DateCalendar,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import moment, { Moment } from "moment";
import { Close } from "@mui/icons-material";
import { Badge, Box, Modal, Typography, styled, Button } from "@mui/material";

const CustomBadge = styled(Badge)(({ theme, invisible }) => ({
  "& .MuiBadge-dot": {
    bottom: "0px",
    left: "50%",
    transform: "translateX(-50%)",
    display: invisible ? "none" : "block",
  },
}));

const modalStyles = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  borderRadius: 4,
  p: 4,
};

const CustomDay = (props: any) => {
  const { day, ...rest } = props;

  const isAvailable =
    !props.outsideCurrentMonth &&
    !props.selected &&
    props.bookabledates.includes(day.format("yyyy-MM-DD"));

  return (
    <CustomBadge
      overlap="circular"
      variant="dot"
      invisible={!isAvailable}
      color="primary"
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <PickersDay day={day} {...rest} />
    </CustomBadge>
  );
};

interface CalendarProps {
  date: Date;
  setDate: (date: Date) => void;
  bookableDates?: string[];
  open: boolean;
  onClose?: () => void;
}

const DatePickerModal: React.FC<CalendarProps> = ({
  date,
  setDate,
  bookableDates,
  open,
  onClose,
}) => {
  const handleDateChange = (date: Moment | null) => {
    if (date) {
      setDate(date.toDate());
    } else {
      setDate(new Date());
    }
  };
  const formattedBookableDates = bookableDates?.map((date) =>
    moment(date).format("yyyy-MM-DD")
  );

  return (
    <Modal open={open}>
      <Box sx={modalStyles}>
        <Button
          sx={{
            backgroundColor: "transparent",
            border: "none",
            position: "absolute",
            right: "1rem",
            color: "black",
          }}
          onClick={onClose}
        >
          <Close />
        </Button>
        <Typography variant="h1">Availability</Typography>
        <Typography variant="body2">
          Green dots indicate bookable experiences
        </Typography>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DateCalendar
            label=""
            value={date ? moment(new Date(date)) : null}
            format="ddd, MMM D, YYYY"
            onChange={handleDateChange}
            slots={{
              day: CustomDay,
            }}
            slotProps={{
              day: {
                // Not sure how to override the type accepted here, so forcing this
                // custom day component to accept bookableDates as an array of dates
                // formatted as "yyyy-MM-DD"
                //@ts-ignore
                bookabledates: formattedBookableDates || [],
              },
            }}
          />
        </LocalizationProvider>
      </Box>
    </Modal>
  );
};

export default DatePickerModal;
